import { FC, useContext, useState, useMemo, useCallback } from "react";
import styles from "./styles.module.scss";
import axios from "axios";
import { Notification, Popover } from '@douyinfe/semi-ui';
import { useRouter } from "next/router";
// import MyModal from "../modal";
import { IndexContext } from "@/stores";


export interface IEnFooterProps {

}

export const EnFooter: FC<IEnFooterProps> = ({

}) => {
  const [visible, setVisible] = useState(false)
  const router = useRouter()
  const { time } = useContext(IndexContext);

  return (
    <div className={styles.footer}>
      <div className={styles.footerMain}>
        <div className={styles.left}>
          <img src="/image/footer-logo.png?v=20250422" alt="" />
          <p>CRAFT BEER CHINA 2026 <br />Conference & Exhibition</p>
          <p style={{ fontSize: '14px' }} className={styles.info}>
            <span className={styles.time}>April 7th - 9th, 2026</span>
            <span className={styles.site}>Shanghai New International Expo Center</span>
          </p>
        </div>
        <div className={styles.middle}>
          <h3>Quick link</h3>
          <ul>
            <li><a href="/en/about/survey">About CBCE</a></li>
            <li><a href="https://cbce2025.gration.cn/?exhibitor/login&lang=en" target="_blank">Exhibitor Center</a></li>
            <li><a href="https://cbce2025.gration.cn/?member/register&lang=en&code=sites" target="_blank">Visitor Center</a></li>
            <li><a href="/en/summit/2025">Technology Conference</a></li>
            <li><a href="/en/schedule">Activities</a></li>
            <li><a href="/en/media/news">Media Center</a></li>
            <li><a href="/en/contacts">Contact Us</a></li>
          </ul>
        </div>
        <div className={styles.right}>
          <h3>Follow us</h3>
          <ul>
            <li>
              <a href="https://www.linkedin.com/in/craft-beer-china-88915036a?fromQR=1" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/30d51834d3fa948a276eb64403b2b0d2.png" alt="" />
              </a>
            </li>
            <li>
              <a href="https://v.douyin.com/NFXodmxAHkc/ 9@0.com" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/876af54adcaf9e4470e33e511482fbff.png" alt="" />
              </a>
            </li>
            <li>
              <a href="https://www.xiaohongshu.com/user/profile/5f5cccbb000000000101d16c?xsec_token=YB_XNj9ey4eGBDnITikPc6BsIHvf8GG6Cd67CqbHFTkQQ=&xsec_source=app_share&xhsshare=CopyLink&appuid=5f5cccbb000000000101d16c&apptime=1754291150&share_id=a16d9bc498994075864959d8d8250075" target="_blank" >
                <img src="http://img.cbcechina.com/2025-08-05/36d6f4803f7a41136b4c1ef614fe6cee.png" alt="" />
              </a>
            </li>
            <li>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wx-account-qr.png" alt="" />
                }
              >
                <img src="http://img.cbcechina.com/2025-08-05/9b174d252a963effeb1cac53618e9477.png" alt="" />
              </Popover>
            </li>
            <li>
              <Popover
                position="top"
                content={
                  <img style={{ width: '150px' }} src="/image/wxqr.jpg?v=2025" alt="" />
                }
              >
                <img src="http://img.cbcechina.com/2025-08-05/82a875113392d4226000bb0e957c1d28.png" alt="" />
              </Popover>
            </li>
          </ul>
        </div>
      </div>
      <div className={styles.copyright}>
        <div>
          <div>
            <a style={{ color: '#fff' }} target="_blank" href="https://www.nuernbergmesse.de/en/company"><p>Copyright © 2022 NürnbergMesse China Co.,Ltd. All rights Reserved</p></a>
            <a style={{ color: '#fff' }} target="_blank" href="http://beian.miit.gov.cn/"><p>沪ICP备09011147号-7</p></a>
          </div>
          <div>
            <div>
              <span>Organizer：</span>
              <img src="/image/messe-logo.png?v=20250422" alt="" />
              <img src="/image/beer.png" alt="" />
            </div>
            <div>
              <span>Support By：</span>
              <a style={{ color: '#fff' }} target="_blank" href="https://www.smartinfo.cn/"><span>SMART-INFO</span></a>
            </div>
          </div>
        </div>

      </div>

      {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
    </div>
  );
};
